export default __webpack_public_path__ + "static/media/ens.696e70b3.svg";